import api from "./core";

const basePath = "api/core/PracticeSuite";

export default {
  isActive() {
    return api.get(`${basePath}/IsActive`);
  },
  getUrlData() {
    return api.get(`${basePath}/GetClientUrl`);
  }
};
